import { render, staticRenderFns } from "./SampleShipment.vue?vue&type=template&id=05cff23a&scoped=true"
import script from "./SampleShipment.vue?vue&type=script&lang=js"
export * from "./SampleShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cff23a",
  null
  
)

export default component.exports